import { render, staticRenderFns } from "./ProjectActionApplyMaxOffersReached.vue?vue&type=template&id=6f4cc967&scoped=true"
import script from "./ProjectActionApplyMaxOffersReached.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectActionApplyMaxOffersReached.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProjectActionApplyMaxOffersReached.vue?vue&type=style&index=0&id=6f4cc967&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4cc967",
  null
  
)

export default component.exports